import { Component, Input } from '@angular/core';
import { ImportData } from 'src/app/models/UserInfo';
import { UserService } from 'src/app/service/user.service';

@Component({
  selector: 'app-print-dialog-dump',
  templateUrl: './print-dialog-dump.component.html',
  styleUrls: ['./print-dialog-dump.component.scss'],
})
export class PrintDialogDumpComponent {
  @Input() displayEffectiveDate: boolean = false;
  @Input() displayRetirementDate: boolean = false;
  @Input() displayESPS: boolean = false;
  @Input() displayMarried: boolean = false;

  public currentUser: ImportData;

  constructor(private userService: UserService) {
    this.currentUser = this.userService.getCurrentUser();
  }

  hasSpouse(): boolean {
    return (
      !!this.currentUser.SPSDOB && this.currentUser.SPSDOB !== 'January 0, 1900'
    );
  }

  isESPS(): boolean {
    return !(this.currentUser.ESPSEURD === 'n/a' || this.currentUser.ESPSStart === 'n/a');
  }

  hasSPP(): boolean {
    return this.currentUser.SPP !== 'N';
  }
}
